import { useEffect } from 'react';
import { Box } from '@mui/material';
import { InputsHeader } from '../InputsHeader';
import { NumericInput, Radio } from '../form-controls';
import { useContext } from '../context';

export function Mode() {
  const name = 'starterFertilizer.mode';
  const { getParam, updateParam } = useContext();
  const isFlat = getParam('starterFertilizer.type') === 'flat';
  const isNormalized = getParam(name) === 'normalized';

  useEffect(() => {
    if (isFlat && !isNormalized) {
      updateParam(name, 'normalized');
    }
  }, [isFlat, isNormalized, updateParam]);

  return (
    <>
      <InputsHeader
        title="Average Gallons"
        subtitle="Average Gallons Per Acre"
        required
        name={name}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: 3 },
        }}
      >
        <Radio
          sx={{ flex: 1, height: 40 }}
          label="Full Fulfillment"
          disabled={isFlat}
          name={name}
          value="full"
        />
        <Radio
          sx={{ flex: 1, height: 40 }}
          label="Average Gallons"
          name={name}
          value="normalized"
        />
        <NumericInput
          sx={{ flex: 1 }}
          disabled={!isNormalized}
          required={isNormalized}
          label="Enter Gallons"
          name="starterFertilizer.targetRate"
        />
      </Box>
    </>
  );
}
